import { fromJS } from 'immutable';
import C from '../../constants';

const initialState = {
  addNewCard: {
    cardType: '',
    validity: {
      validCardNumber: false,
      validExpiryMonth: false,
      validExpiryYear: false,
      validCvv: false,
      isExpired: false,
    },
  },
  purchaserDetails: {
    loading: false,
    error: null,
    data: {
      id: '',
      paymentMethodId: '',
      paymentMethodTypes: {
        value: [],
        display: '',
      },
      defaultPaymentMethodType: {
        value: '',
        display: '',
      },
      paymentMethod: {
        id: '',
      },
    },
  },
};

export const cardsReducer = (
  state = fromJS(initialState.addNewCard),
  action
) => {
  switch (action.type) {
    case C.GET_CARD_TYPE_PENDING: {
      return state.merge({
        loading: true,
      });
    }
    case C.GET_CARD_TYPE_FULFILLED: {
      let { data } = action.payload;
      if (data) {
        data = data.toLowerCase();
      }
      return state.merge({
        loading: false,
        error: null,
        cardType: data,
      });
    }
    case C.GET_CARD_TYPE_REJECTED: {
      const error = action.payload;
      return state.merge({
        loading: false,
        error,
      });
    }

    case C.VALIDATE_CARD_PENDING: {
      return state.merge({
        loading: true,
      });
    }
    case C.VALIDATE_CARD_FULFILLED: {
      const { data } = action.payload;
      return state.merge({
        loading: false,
        error: null,
        validity: data,
      });
    }
    case C.VALIDATE_CARD_REJECTED: {
      const error = action.payload;
      return state.merge({
        loading: false,
        error,
      });
    }

    case C.CLEAR_CARD_VALIDATIONS: {
      return state.merge(initialState);
    }

    default:
      return state;
  }
};

export const purchaserReducer = (
  state = fromJS(initialState.purchaserDetails),
  action
) => {
  switch (action.type) {
    case C.FETCH_PURCHASER_DETAILS_PENDING: {
      return state.merge({
        loading: true,
      });
    }
    case C.FETCH_PURCHASER_DETAILS_FULFILLED: {
      const { data } = action.payload;
      return state.merge({
        loading: false,
        error: null,
        data,
      });
    }
    case C.FETCH_PURCHASER_DETAILS_REJECTED: {
      const error = action.payload;
      return state.merge({
        loading: false,
        error,
      });
    }
    default:
      return state;
  }
};
